import Container from './LandingContainer'
import Button from '@/components/ui/Button'
import AuroraBackground from './AuroraBackground'
import Copyright from '@/components/shared/Copyright'
import { motion } from 'framer-motion'
import { router } from '@inertiajs/react'
import type { Mode } from '@/@types/theme'

const LandingFooter = ({ mode: _mode }: { mode: Mode }) => {
    const handleStartFree = () => {
        // TODO: confirm canonical early-access signup route (currently /register)
        router.visit('/register')
    }

    return (
        <div id="footer" className="relative z-20">
            <Container className="relative">
                <div className="py-10 md:py-20">
                    <AuroraBackground
                        className="rounded-3xl"
                        auroraClassName="rounded-3xl"
                    >
                        <motion.div
                            initial={{ opacity: 0.0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 0.3,
                                duration: 0.3,
                                ease: 'easeInOut',
                            }}
                            className="relative flex flex-col gap-4 items-center justify-center py-20 px-8 text-center"
                        >
                            <h2 className="text-5xl">Start with one working note</h2>
                            <p className="mt-4 max-w-[520px] mx-auto">
                                Capture an idea, draft a decision, or keep project
                                context in one private workspace.{' '}
                                <span
                                    className="inline-flex items-baseline whitespace-nowrap tracking-tight"
                                    aria-label="MemoSlate"
                                >
                                    <span className="text-primary">Memo</span>
                                    <span className="bg-gradient-to-r from-primary to-rose-500 bg-clip-text text-transparent">Slate</span>
                                </span>{' '}
                                is open for early users.
                            </p>
                            <div className="mt-6">
                                <Button variant="solid" onClick={handleStartFree}>
                                    Start free early access
                                </Button>
                            </div>
                        </motion.div>
                    </AuroraBackground>
                </div>
            </Container>
        </div>
    )
}

export default LandingFooter
